<template>
  <div
    class="teaser group mb-6 sm:mb-12 flex flex-row sm:flex-col gap-4 sm:gap-0 items-start text-start border-0 shadow-none"
  >
    <div
      class="teaser-image w-[127px] sm:w-full object-cover relative mb-6 rounded-[4px] overflow-hidden h-auto"
    >
      <div class="relative">
        <MediaImage
          v-if="media"
          v-bind="media"
          :image-style="imageStyle"
          hide-caption
          class="rounded-[4px] w-full h-auto object-cover shrink-0"
        />
        <div
          v-else-if="isPerson"
          class="rounded-[4px] flex items-center justify-center w-full h-auto object-cover shrink-0 bg-lightGreenBg aspect-[412/309]"
        >
          <SpriteSymbol
            name="person"
            class="size-4 sm:size-40 text-darkGreen opacity-80 transition-all duration-300 ease-in-out group-hover:opacity-100"
          />
        </div>
        <div
          v-else
          class="rounded-[4px] flex items-center justify-center w-full h-auto object-cover shrink-0 bg-lightGreenBg aspect-[412/309]"
        />
        <div
          class="teaser-arrow absolute bottom-2 right-3 sm:bottom-8 sm:right-8 sm:flex"
        >
          <div
            v-if="tag"
            class="bg-lightGreenBg text-darkGreen rounded-full h-6 sm:h-14 px-7 mr-2 hidden sm:flex items-center justify-center transition-all duration-300 shadow-lg border-none cursor-pointer"
          >
            {{ tag }}
          </div>
        </div>
      </div>
      <div
        v-if="tag"
        class="bg-lightGreenBg text-darkGreen text-[10px] mt-2 w-full rounded-full h-6 sm:h-14 px-3 mr-2 flex sm:hidden items-center justify-start transition-all duration-300 border-none cursor-pointer"
      >
        {{ tag }}
      </div>
    </div>
    <div class="w-full sm:flex-1 flex flex-col justify-start">
      <h3 class="mb-3 sm:mb-5 text-lg sm:text-xl">
        {{ title }}
      </h3>
      <div
        v-if="text"
        class="text-xs sm:text-base whitespace-pre-wrap"
        v-html="text"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'

withDefaults(
  defineProps<{
    title: string
    text?: string
    media?: MediaImageFragment
    tag?: string
    isPerson?: boolean
  }>(),
  {
    text: '',
    tag: undefined,
    media: undefined,
    isPerson: false,
  },
)

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 4 / 3,
  sizes: {
    xs: 608,
    sm: 360,
    md: 304,
    lg: 412,
  },
})
</script>
